import React from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { Card, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Redirect } from "react-router-dom";

import OrdersList from './OrdersList';
import TicketsList from './TicketsList';

function OrdersContainer(props) {
    const { t } = useTranslation();

    const { eventID, url } = props;

    const ordersAndProductsDisabledEvents = ['8973cebe-8916-11ea-a21a-ee6a04371b85']; // List of events that have orders and products disabled.

    if(ordersAndProductsDisabledEvents.includes(eventID)) {
        return <Redirect to={`/`} />
    }

    return (
        <React.Fragment>
            <h3>{t('orders.header')}</h3>
            <Card className="mb-0">
                <Card.Header>
                    <Nav variant="tabs">
                        <Nav.Item>
                            <NavLink to={`${url}`} strict exact className="nav-link">{t('orders.header')}</NavLink>
                        </Nav.Item>
                        <Nav.Item>
                            <NavLink to={`${url}/tickets`} className="nav-link">{t('orders.tickets')}</NavLink>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
            </Card>
            <Switch>
                <Route path={`/events/:eventID/orders/tickets`}>
                    <TicketsList
                        eventID={eventID}
                        limit={25}
                    />
                </Route>    
                <Route strict exact path={`${url}`}>
                    <OrdersList
                        eventID={eventID}
                        limit={25}
                    />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default OrdersContainer;